module.exports = __webpack_public_path__ + "static/media/ag.30813318.svg";